import { LitElement, css, html } from 'lit';
import { customElement, query } from 'lit/decorators';

import { GOOGLE_KEY, overridePaperInputPlaceChanged } from '../../helpers/api/google-api';
import { Location } from '../../types';
import { Select } from '@material/mwc-select';
import { TextField } from '@material/mwc-textfield';
import { delay } from '../../helpers/utils';
import { removeInertFromLocationElement } from '../../helpers/inert';

@customElement('topic-center-input')
export class TopicCenterInput extends LitElement {
    @query('#defaultCenter')
    private defaultCenterElement!: any | TextField;

    @query('#defaultZoom')
    private readonly defaultZoomElement!: Select;

    public get defaultCenterIsValid(): boolean {
        return !this.defaultCenterElement.invalid;
    }

    public get defaultCenterValue(): Location {
        return this.defaultCenterElement.value as Location;
    }

    public get defaultZoomValue(): string {
        return this.defaultZoomElement.value;
    }

    async firstUpdated(_changedProperties: any) {
        await this.startup();
    }

    private async startup() {
        await this.fixDefaultCenterElement();
    }

    private async fixDefaultCenterElement() {
        while (!this.defaultCenterElement) {
            await delay(10);
        }

        // Since we don't explicitly await the google key retrieval this technically
        // sets off a race condition. Practically, since the key retrieval is the first of
        // a couple API calls, it should not be a concern.
        this.defaultCenterElement.apiKey = GOOGLE_KEY;

        // Sort of hack to make the input not "red".
        this.defaultCenterElement._setInvalid(false);
    }

    protected render() {
        return html`
            <div id="container">
                <paper-input-place
                    id="defaultCenter"
                    class="input"
                    label="Map Center Location"
                    @click="${removeInertFromLocationElement}"
                    @api-loaded="${() => overridePaperInputPlaceChanged(this.defaultCenterElement)}"
                ></paper-input-place>
                <div style="min-width: 5%;"></div>
                <mwc-select id="defaultZoom" class="input" label="Zoom Level">
                    <mwc-list-item value="1">1 - World</mwc-list-item>
                    <mwc-list-item value="3">3 - Hemisphere</mwc-list-item>
                    <mwc-list-item value="5">5 - Continent</mwc-list-item>
                    <mwc-list-item value="7">7 - Region</mwc-list-item>
                    <mwc-list-item value="9">9 - Province</mwc-list-item>
                    <mwc-list-item selected value="11">11 - Large City</mwc-list-item>
                    <mwc-list-item value="13">13 - Small City</mwc-list-item>
                    <mwc-list-item value="15">15 - Neighborhood</mwc-list-item>
                    <mwc-list-item value="17">17 - Block</mwc-list-item>
                    <mwc-list-item value="19">19 - Street</mwc-list-item>
                    <mwc-list-item value="21">21 - Grain of Sand</mwc-list-item>
                </mwc-select>
            </div>
        `;
    }

    static get styles() {
        return css`
            .input {
                width: 100%;
            }

            #container {
                display: flex;
                flex-direction: row;
                width: 100%;
            }
        `;
    }
}
